import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';

@Injectable()
export class DeclarationsDechetsMenagersService {
    private urlGetDeclarationPeTonnage: string = '';
    private urlGetDechetsMenagersTonnages: string = '';
    private urlSaveDechets: string = '';
    private urlPartnersByType: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetDeclarationPeTonnage = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetDeclarationPeTonnage?idDett=';
        this.urlGetDechetsMenagersTonnages = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetDechetsMenagersTonnages?idDett=';
        this.urlSaveDechets = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/SaveDechetsMenagers?idDett=';
        this.urlPartnersByType = _appConfig.getConfig().nPointDeclarations + '/utom/GetPartnersByTypes?';
    }


    getDeclarationPeTonnagee(declaId): Observable<any> {
        return this.http.get(this.urlGetDeclarationPeTonnage + declaId)
            .catch(this.handleError);
    }

    getDechetsMenagersTonnages(declaId, idTdd): Observable<any> {
        return this.http.get(this.urlGetDechetsMenagersTonnages + declaId + '&idTdd=' + idTdd)
            .catch(this.handleError);
    }


    getPartnersByType(types: number[]): Observable<any> {
        const postUrl = types.map(num => 'idsTpn=' + num).join('&');
        return this.http.get(this.urlPartnersByType + postUrl)
            .catch(this.handleError);
    }


    saveDechets(declaId, dechets): Observable<any> {
        return this.http.post(this.urlSaveDechets + declaId, dechets)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-dechets-menagers.service.ts